module.exports = __webpack_public_path__ + "media/images/products/widgets/1-84453d4620ebe29a5295ea47a230cb4e.png";